// Mock data for Tha Advocate Beats
// Demo data cleared — real content managed via admin dashboard

export const featuredBeats = [];

export const allBeats = [];

export const soundKits = [];

export const albums = [];

export const merchItems = [];

export const genres = ['All', 'Hip Hop', 'Trap', 'R&B', 'Lo-Fi', 'Boom Bap', 'Drill'];
export const moods = ['All', 'Dark', 'Aggressive', 'Hard', 'Smooth', 'Energetic', 'Soulful', 'Mystical', 'Upbeat', 'Inspiring', 'Exciting', 'Fun'];
export const bpmRanges = ['All', '80-95', '96-110', '111-130', '131-150', '150+'];

// Enhanced theme options with shinier, more vibrant colors
export const themes = [
  { id: 'gold', name: 'Golden Era', primary: '#FFD700', secondary: '#1a1a1a', accent: '#FFA500' },
  { id: 'platinum', name: 'Platinum Ice', primary: '#E5E4E2', secondary: '#2d2d2d', accent: '#B0C4DE' },
  { id: 'emerald', name: 'Emerald Shine', primary: '#50C878', secondary: '#0a0a0a', accent: '#00FF7F' },
  { id: 'sapphire', name: 'Sapphire Glow', primary: '#0F52BA', secondary: '#000000', accent: '#1E90FF' },
  { id: 'ruby', name: 'Ruby Fire', primary: '#E0115F', secondary: '#1a0000', accent: '#FF1493' },
  { id: 'amethyst', name: 'Amethyst Dream', primary: '#9966CC', secondary: '#1a0a1a', accent: '#DA70D6' },
  { id: 'copper', name: 'Copper Sunset', primary: '#FF6347', secondary: '#1a1a1a', accent: '#FF4500' },
  { id: 'neon-cyan', name: 'Neon Cyan', primary: '#00FFFF', secondary: '#0a0a0a', accent: '#00CED1' },
  { id: 'electric-purple', name: 'Electric Purple', primary: '#BF00FF', secondary: '#0a0000', accent: '#9400D3' },
  { id: 'lime-burst', name: 'Lime Burst', primary: '#CCFF00', secondary: '#1a1a1a', accent: '#ADFF2F' },
  { id: 'hot-pink', name: 'Hot Pink Vibes', primary: '#FF69B4', secondary: '#1a0a1a', accent: '#FF1493' },
  { id: 'orange-blaze', name: 'Orange Blaze', primary: '#FF8C00', secondary: '#1a0a0a', accent: '#FFA500' },
  { id: 'teal-shine', name: 'Teal Shine', primary: '#00CED1', secondary: '#0a1a1a', accent: '#20B2AA' },
  { id: 'crimson-steel', name: 'Crimson Steel', primary: '#DC143C', secondary: '#1a1a1a', accent: '#B22222' },
  { id: 'metallic-gold', name: 'Metallic Gold', primary: '#D4AF37', secondary: '#0a0a0a', accent: '#F4C430', gradient: 'linear-gradient(135deg, #FFD700, #FFA500, #FFD700, #DAA520)' },
  { id: 'metallic-red', name: 'Metallic Red', primary: '#AA0000', secondary: '#1a0000', accent: '#CC0000', gradient: 'linear-gradient(135deg, #DC143C, #8B0000, #DC143C, #B22222)' },
  { id: 'metallic-green', name: 'Metallic Green', primary: '#2ecc71', secondary: '#0a0a0a', accent: '#27ae60', gradient: 'linear-gradient(135deg, #2ecc71, #27ae60, #2ecc71, #16a085)' }
];
